import React, { useState, useEffect } from "react";
import "./App.css";
import TrailerPlayer from "./components/TrailerPlayer";
import LatestMovieTheme from "./components/LatestMovieTheme";
import { db } from "./firebase";
import { collection, query, where, getDocs } from "firebase/firestore";

const App = () => {
  const [latestTheme, setLatestTheme] = useState("");
  const [movies, setMovies] = useState([]);

  // ✅ Fetch movies from Firebase where theme === latestTheme
  useEffect(() => {
    const fetchMoviesForLatestTheme = async () => {
      try {
        if (!latestTheme) {
          console.warn("⚠️ No latest theme available yet.");
          return;
        }

        console.log("🔍 Fetching movies for theme:", latestTheme);

        const q = query(
          collection(db, "submissions"),
          where("theme", "==", latestTheme.trim()) // ✅ Only fetch movies with this theme
        );
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          console.warn("⚠️ No movies found for theme:", latestTheme);
          setMovies([]); // Clear movies if none found
        } else {
          const movieList = querySnapshot.docs.map((doc) => doc.data().movie);
          console.log("🎬 Movies for", latestTheme, ":", movieList);
          setMovies(movieList);
        }
      } catch (error) {
        console.error("❌ Error fetching movies:", error);
      }
    };

    fetchMoviesForLatestTheme();
  }, [latestTheme]); // ✅ Runs every time the latest theme updates

  return (
    <div>
      <LatestMovieTheme setThemeTitle={setLatestTheme} />
      <TrailerPlayer movies={movies} />
      {/* Add the "Back to movieclub" link */}
      <div className="back-link-container">
        <a href="https://www.badovinac.ca" className="back-link">
          Back to movieclub
        </a>
      </div>
    </div>
  );
};

export default App;
